export default __webpack_public_path__ + "static/media/Sami.23edbf73.png";